import LinkToGitHub from "../../../../src/components/atoms/link-to-github.tsx";
import Prompt from "../../../../posts/2021-06-12-dotfiles/shell-prompt.tsx";
import * as React from 'react';
export default {
  LinkToGitHub,
  Prompt,
  React
};